import React, { Component } from 'react'
import '../styles/ModuleCollection.css'
import OrgFooter from '../widgets/OrgFooter'
import AlertMessage from '../widgets/AlertMessage'
import ActivityIndicator from '../widgets/ActivityIndicator'
import deleteIcon from '../images/delete.png'
import addIcon from '../images/add.png'
import DropdownWidget from '../widgets/DropdownWidget'
import APICalendarRequest from '../api/APICalendarRequest'

class ModuleCollection extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			moduleList: [],
			itemObj: {},
			keyTracer: 0,
			modules: {},
			deleteModules: {},
			disabled: props.disabled,
		}
		this.setScrollable = this.setScrollable.bind(this)
		this.setModuleList = this.setModuleList.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
		this.getAllParticipantTypes = this.getAllParticipantTypes.bind(this)
		this.getAllTrainingModules = this.getAllTrainingModules.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.addTrainingModule = this.addTrainingModule.bind(this)
		this.editTrainingModule = this.editTrainingModule.bind(this)
	}

	onSubmit() {
		this.setState({showActivityIndicator: true})
		const modules = []
		const addModules = []
		Object.values(this.state.modules).forEach((v) => {
			if(v.training_module_id == null) {
				addModules.push(v)
			}
			else {
				modules.push(v)
			}
		})
		Object.values(this.state.deleteModules).forEach((v) => {
			modules.push(v)
		})
		if(modules.length < 1) {
			const data = {trainingModule: addModules}
			this.addTrainingModule(data)
		}
		else {
			const data = {}
			if(modules.length > 0) {
				data["trainingModule"] = modules
			}
			if(addModules.length > 0) {
				data["add"] = addModules
			}
			this.editTrainingModule(data)
		}
	}

	addTrainingModule(data) {
		const apiReq = APICalendarRequest.addTrainingModule(this.state.accessToken, data)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
			})
		})
	}

	editTrainingModule(data) {
		const apiReq = APICalendarRequest.editTrainingModule(this.state.accessToken, data)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.results,
					showActivityIndicator: false
				})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description + ": " + response.error,
					showActivityIndicator: false
				})
				return
			}
			this.setState({
				showInfoMessage: true,
				aMessage: response.status + "! " + response.description,
				showActivityIndicator: false,
			})
		})
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize.bind(this))
		this.setScrollable()
		this.getAllTrainingModules((modules) => {
			this.getAllParticipantTypes((pTypes) => {
				this.setModuleList(modules, pTypes)
			})
		})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize.bind(this))
	}

	getAllTrainingModules(callback) {
		const apiReq = APICalendarRequest.getAllTrainingModules(this.state.accessToken);
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false});
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({
					training_module_id: v.training_module_id,
					name: v.name,
					participant_type_id: v.participant_type_id});
			}
			this.setState({trainingModules: c, showActivityIndicator: false});
			callback(c)
		})
	}

	getAllParticipantTypes(callback) {
		const apiReq = APICalendarRequest.getAllParticipantTypes(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false});
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.participant_type_id, name: v.name})
			}
			this.setState({participantTypes: c, showActivityIndicator: false})
			callback(c)
		})
	}

	onResize() {
		this.setScrollable()
	}

	setModuleList(modules, participantTypes) {
		const members = []
		if(modules != null) {
			for(const v of modules) {
				const mKey = "m-" + this.state.keyTracer
				this.state.itemObj[mKey] = <Module data={v} handler={this.eventHandler}
					participantTypes={participantTypes} disabled={this.state.disabled}  key={mKey} id={mKey} />
				this.state.keyTracer++
			}
			const mKey = "m-" + this.state.keyTracer
			this.state.itemObj[mKey] = <Module handler={this.eventHandler}
				participantTypes={participantTypes} disabled={this.state.disabled} key={mKey} id={mKey} />
			this.state.keyTracer++
			Object.keys(this.state.itemObj).forEach((k => {
				members.push(this.state.itemObj[k])
			}))
		}
		else {
			const mKey = "m-" + this.state.keyTracer
			this.state.itemObj[mKey] = <Module handler={this.eventHandler}
				participantTypes={participantTypes} disabled={this.state.disabled} key={mKey} id={mKey} />
			this.state.keyTracer++
			members.push(this.state.itemObj[mKey])
		}
		this.setState({moduleList: members, showActivityIndicator: false})
		this.setScrollable()
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "module":
				this.state.modules[compId] = value
				break
			case "add":
				const added = []
				const mKey = "m-" + this.state.keyTracer
				this.state.itemObj[mKey] = <Module handler={this.eventHandler}
					participantTypes={this.state.participantTypes} key={mKey} id={mKey} />
				this.state.keyTracer++
				Object.keys(this.state.itemObj).forEach((k => {
					added.push(this.state.itemObj[k])
				}))
				this.setState({moduleList: added})
				break
			case "delete":
				value["is_archived"] = 1
				this.state.deleteModules[compId] = value
				delete this.state.itemObj[compId]
				const deleted = []
				Object.keys(this.state.itemObj).forEach((k => {
					deleted.push(this.state.itemObj[k])
				}))
				this.setState({moduleList: deleted})
		}
		this.setScrollable()
	}

	setScrollable() {
		const sa = document.getElementById('mc-scroll-area')
		const ca = document.getElementById('mc-client-area')
		if(ca == null || sa == null) {
			return
		}
		if(sa.clientHeight < ca.clientHeight+100) {
			this.setState({scrollable: true})
		}
		else {
			this.setState({scrollable: false})
		}
	}

	render() {
		const view = <div id="module-collection">
			<div id="mc-scroll-area"><div id="mc-client-area">
				<div id="mc-cell">
					<table className="mc-table-header">
						<col style={{width: '60%'}} />
						<col style={{width: '40%'}} />
						<tr>
							<th><div>Module Title</div></th>
							<th><div>Participant Type</div></th>
						</tr>
					</table>
					{this.state.moduleList}
				</div>
			</div>{(this.state.scrollable === true && !this.state.disabled) && <OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} />}</div>
			{(this.state.scrollable === false && !this.state.disabled)  && <div className="alternate-footer"><OrgFooter submit={this.onSubmit}
				showSubmit={true} disabled={this.state.isViewDetails} /></div>}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					this.setState({showInfoMessage: false})
			}} />}
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class Module extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			disabled: props.disabled,
			participantTypes: props.participantTypes,
			moduleDetails: (props.data != null)? props.data: {},
			parType: "-- SELECT --"
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		this.getParticipantTypeById = this.getParticipantTypeById.bind(this)
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.getParticipantTypeById()
			this.state.moduleDetails = this.props.data
			if(this.state.disabled) {
				var addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" />
			}
			else {
				addDeleteButton = <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />
			}
			this.setState({
				title: this.props.data.name,
				addDeleteButton: addDeleteButton
			})
			return
		}
		if(this.state.disabled) {
			this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" />})
			return
		}
		this.setState({addDeleteButton: <img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
	}

	getParticipantTypeById() {
		this.setState({showActivityIndicator: true})
		const apiReq = APICalendarRequest.getParticipantTypeById(this.state.accessToken, this.props.data.participant_type_id);
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({parType: response.results.name})
		})
	}

	onAddItemClick() {
		this.props.handler("add", this.state.itemId, null, this.state.title)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.props.handler("delete", this.state.itemId, null, this.state.moduleDetails)
	}

	render() {
		const view = <div className="module">
			<div>{this.state.addDeleteButton}</div>
			<table className="mc-table-data">
				<col style={{width: '60%'}} />
				<col style={{width: '40%'}} />
				<tr>
					<td>
						<input className="module-title" type="text" placeholder={this.state.title} onChange={(e) =>{
							this.state.moduleDetails["name"] = e.target.value.toUpperCase()
							this.props.handler("module", this.state.itemId, null, this.state.moduleDetails)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
					<td>
						<DropdownWidget list={this.state.participantTypes} placeholder={this.state.parType}
						cStyle={{'width': '100%'}} onItemSelected={(id, val) => {
							this.state.moduleDetails["participant_type_id"] = id
							this.props.handler("module", this.state.itemId, null, this.state.moduleDetails)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} disabled={this.state.disabled} />
					</td>
				</tr>
			</table>

		</div>
		return(view)
	}
}

export default ModuleCollection
